import { TopicShortcut } from '../../../../../models/channels/types';

export function mapShortcutLinks(
  links: TopicShortcut['links'],
  allowRiskyLinksEnabled: boolean
) {
  return links.map(({ name, url, allow_referrer }) => ({
    url,
    label: name,
    allowReferrer: allowRiskyLinksEnabled && Boolean(allow_referrer),
  }));
}
